export enum CommentPageActions {
  COMMENTS_LOADED = 'COMMENTS_LOADED',
  UPVOTE_COMMENT = 'UPVOTE_COMMENT',
  DOWNVOTE_COMMENT = 'DOWNVOTE_COMMENT',
  ADD_NEW_COMMENT = 'ADD_NEW_COMMENT',
  ADD_REPLY = 'ADD_REPLY',
  UPDATE_COMMENT = 'UPDATE_COMMENT',
  DELETE_COMMENT = 'DELETE_COMMENT'
}
